import { render, staticRenderFns } from "./_base-textarea.vue?vue&type=template&id=6b831928&scoped=true&"
import script from "./_base-textarea.vue?vue&type=script&lang=js&"
export * from "./_base-textarea.vue?vue&type=script&lang=js&"
import style0 from "./_base-textarea.vue?vue&type=style&index=0&id=6b831928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b831928",
  null
  
)

export default component.exports